<template>
  <div class="observa4-results row">
    <div class="col-xs-12" v-if="distribution != null">
      <tabs justified>
        <tab>
          <div slot="title">
            <h3>
              <i class="glyphicon glyphicon-th"></i>
              Faits&nbsp;marquants<br>
              <small>
                Parcourez vos résultats par thèmes et par fiches
              </small>
            </h3>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-10" v-if="highlight.m != null">
              <div class="row">
                <div class="xportpdf">
                  <div class="action-bar">
                    <btn type="primary" @click="printToPdf('bySheet')" size="sm"
                         :disabled="pdf.generate">
                      <span class="glyphicon glyphicon-download-alt"
                            aria-hidden="true">
                      </span>
                      Exporter PDF par fiches
                    </btn>
                  </div>
                  <div class="action-bar">
                    <btn type="primary" @click="printToPdf('byTheme')" size="sm"
                         :disabled="pdf.generate">
                      <span class="glyphicon glyphicon-download-alt"
                            aria-hidden="true">
                      </span>
                      Exporter PDF par thèmes
                    </btn>
                  </div>
                </div>
                <div class="col-xs-12">
                  <div :class="`result-title-${highlight.s}`">
                    <div class="result-title text-center">
                      {{ sc.titles[highlight.m][highlight.s] }}<br>
                      <small v-if="sc.subTitles[highlight.m]">{{sc.subTitles[highlight.m][highlight.s]}}</small>
                    </div>
                    <div class="text-center">
                      <span class="filter-label" v-for="(c, k) in filter" :key="`filter-${k}`">
                        <span class="label" :class="`label-${k}`">
                          {{ sc.priority[k] }}
                        </span>
                      </span>
                    </div>

                    <btn size="xs" :class="`btn-${prevHighlight.s} pull-left`" @click="goToPrevHighlight">
                      <strong>
                        <span class="glyphicon glyphicon-arrow-left">
                        </span>
                        {{ sc.cat[prevHighlight.m][prevHighlight.s] }}
                      </strong>
                    </btn>

                    <btn size="xs" :class="`btn-${nextHighlight.s} pull-right`" @click="goToNextHighlight">
                      <strong>
                        {{ sc.cat[nextHighlight.m][nextHighlight.s] }}
                        <span class="glyphicon glyphicon-arrow-right">
                        </span>
                      </strong>
                    </btn>
                  </div>
                </div>
              </div>
              <div class="highlight-main">
                <div v-for="(o, k) in finalHighlight"
                     class="highlight"
                     :key="`obs-${k}`">
                  <div :class="`result-container-${o.class}`">
                    <div class="highlight-title">
                      {{o.title}}<br>
                      <small v-if="o.subTitle">{{o.subTitle}}</small>
                    </div>
                    <div class="highlight-container">
                      <div v-for="(l, n) in o.values" :key="`obs-${k}-${n}`"
                           class="result-container" :class="l.ccl">
                        <o4-pellet :data="l">
                        </o4-pellet>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-sm-2">
              <div class="row" v-if="highlightMenu">
                <div v-for="m in highlightMenu.cats" :key="m.key" class="col-xs-12">
                  <h4 class="text-center">{{ m.title }}</h4>
                  <div class="menu-container">
                    <div v-for="c in m.list" :key="`${m.key}-${c.key}`">
                      <div class="menu-buttons"
                           :class="{ 'menu-buttons-active': c.key === highlight.s && m.key === highlight.m }">
                        <btn role="button" @click="selectHighlight(c.index)"
                             :class="`btn-${c.key}`" size="xs">
                          {{ c.title }}
                        </btn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab>
        <tab>
          <div slot="title" class="tab-title">
            <h3>
              <i class="glyphicon glyphicon-list"></i>
              Vue&nbsp;d'ensemble<br>
              <small>
                Analysez le tableau récapitulatif de vos résultats
              </small>
            </h3>
          </div>
          <div>
            <div class="row">
              <div class="col-xs-12">
                <div class="row">
                  <div class="action-bar">
                    <btn type="primary" @click="printToPdf('table')" size="sm"
                         :disabled="pdf.generate">
                      <span class="glyphicon glyphicon-download-alt"
                            aria-hidden="true">
                      </span>
                      Exporter en PDF
                    </btn>
                  </div>
                  <div class="filter-container col-lg-8 col-xs-12">
                    <h4>Fiches</h4>
                    <span class="sheet-filter" v-for="(c, k) in sheetFilter" :key="`sheet-filter-${k}`">
                      <c-checkbox :type="k" v-model="sheetFilter[k]" size="xs">
                        {{ sc.cat.bySheet[k] }}
                      </c-checkbox>
                    </span>
                  </div>
                  <div class="filter-container col-lg-4 col-xs-12">
                    <h4>Conformité</h4>
                    <span class="filter" v-for="(c, k) in filter" :key="`filter-${k}`">
                      <c-checkbox :type="filter[k].style" v-model="filter[k].tick" size="xs">
                        {{ sc.priority[k] }}
                      </c-checkbox>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <o4-result-table :sheetFilter="sheetFilter" :summary="summary">
            </o4-result-table>
          </div>
        </tab>
        <tab>
          <div slot="title">
            <h3>
              <i class="glyphicon glyphicon-search"></i>
              Caractéristiques<br>
              <small>
                Explorez en détail le contenu des fiches saisies
              </small>
            </h3>
          </div>
          <div>
            <div v-if="flatDistribution != null && flatDistribution.length > 0">
              <sui-results-caracteristics
                :caracteristics="flatDistribution"
                :title="`${title} - CARACTÉRISTIQUES OBSERVA4`"
                :subtitle="subtitle">
                <p>Aucune fiche pour cet établissement.</p>
              </sui-results-caracteristics>
            </div>
            <div v-else>
              <alert type="warning">
                <strong>
                  Aucune fiche n'a été remplie par cet établissement.
                </strong>
              </alert>
            </div>
          </div>
        </tab>
      </tabs>
    </div>
    <div class="col-xs-12" v-if="pdf.generate" v-show="false">
      <component
        ref="o4print"
        :is="pdf.component"
        :subTitle="title"
        :viewType="pdf.viewType"
        :data="pdf.data"
        :counts="distribution.obsManagment"
        :year="year"
        :complianceLadder="filter">
      </component>
    </div>
    <modal v-model="pdf.generate"
           :backdrop="false" :header="false" :dismiss-btn="false"
           :keyboard="false" :footer="false">
      <div v-if="pdf.generate">
        <h4 class="text-center">
          {{ pdf.filename }}
        </h4>
        <hr>
        <div class="text-center" v-if="pdf.progress != null">
          <strong>
            Construction du PDF en cours...
            <br>
            Page {{ pdf.count }} / {{ pdf.total }}
          </strong>
          <progress-bar label type="success" v-model="pdf.progress">
          </progress-bar>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import suiResultsCaracteristics from '@/sui/components/results/caracteristics'
import caracteristics from '@/sui/data/caracteristics'
import checkbox from '@/sui/components/checkbox'
import impl from '@/sui/components/results/impl/observa4'
import sc from '@/sui/components/results/sc/observa4'
import o4Pellet from '@/sui/components/results/observa4Pellet'
import pdf from '@/sui/tools/pdf'
import assert from '@/sui/tools/assert'
import o4PrintPelletView from '@/sui/components/results/o4PrintPelletView'
import o4PrintTableView from '@/sui/components/results/o4PrintTableView'
import observa4ResultTable from '@/sui/components/results/observa4ResultTable.vue'

function getPdfPresets (type) {
  if (type === 'bySheet' || type === 'byTheme') {
    return {
      componentName: 'o4-print-pellet-view',
      jsPDFOpt: { unit: 'cm', format: 'a4', orientation: 'portrait' },
      getRawData: function (vm) {
        return vm.obsHighlight
      }
    }
  }

  if (type === 'table') {
    return {
      componentName: 'o4-print-table-view',
      jsPDFOpt: { unit: 'cm', format: 'a4', orientation: 'landscape' },
      getRawData: function (vm) {
        return {
          sheetFilter: vm.sheetFilter,
          summary: vm.summary
        }
      }
    }
  }
}

export default {
  name: 'establishment-o4-results',

  props: {
    title: {
      type: String,
      required: true
    },

    subtitle: {
      type: String,
      default: ''
    },

    distribution: {
      type: Object,
      required: true
    },

    region: {
      type: Boolean,
      default: false
    },

    year: {
      type: Number,
      required: true
    }
  },

  data: function () {
    const sheetFilter = {
      p1: true,
      p2: true,
      p3: true
    }

    if (this.year >= 2022) {
      sheetFilter.p4 = true
    }
    sheetFilter.b1 = true
    sheetFilter.b2 = true
    if (this.year >= 2023) {
      sheetFilter.r1 = true
    }

    return {
      highlightIndex: 0,
      pdf: {
        viewType: null,
        generate: false,
        progress: null,
        component: null,
        data: null,
        count: 0,
        total: 0
      },
      filter: {
        gray: { tick: true, style: 'gray' },
        danger: { tick: true, style: 'danger' },
        warning: { tick: true, style: 'warning' },
        success: { tick: true, style: 'success' },
        info: { tick: true, style: 'cb-info' }
      },

      sheetFilter: sheetFilter,
      sc: sc
    }
  },

  computed: {
    highlight: function () {
      if (this.obsHighlight == null) {
        return { m: null, s: null }
      }

      return this.indexToHighlight(this.highlightIndex)
    },

    nextHighlight: function () {
      if (this.obsHighlight == null) {
        return { m: null, s: null }
      }

      return this.indexToHighlight(this.highlightIndex + 1)
    },

    prevHighlight: function () {
      if (this.obsHighlight == null) {
        return { m: null, s: null }
      }

      return this.indexToHighlight(this.highlightIndex - 1)
    },

    highlightMenu: function () {
      if (this.obsHighlight == null) {
        return null
      }

      const nav = []
      const cats = []
      for (let c in this.obsHighlight) {
        const hl = this.obsHighlight[c]
        const list = []
        for (let k in hl) {
          nav.push({ m: c, s: k })
          list.push(
            {
              key: k,
              index: nav.length - 1,
              title: sc.cat[c][k]
            }
          )
        }
        cats.push(
          {
            title: sc.cat[c].title,
            key: c,
            list: list
          }
        )
      }
      return {
        nav: nav,
        cats: cats
      }
    },

    summary: function () {
      const source = impl.summary(
        this.distribution, sc.facts, parseInt(this.year)
      )
      const result = []
      const f = this.filter

      for (let i = 0; i !== source.length; ++i) {
        const c = source[i]
        const nl = []
        let countTitles = 0
        for (let j = 0; j !== c.lines.length; ++j) {
          const l = c.lines[j]
          const item = {
            label: l.l,
            main: j === 0
          }

          let has = false
          for (let k in this.sheetFilter) {
            if (!this.sheetFilter[k] || l[k] == null || l[k].v.total === 0) {
              continue
            }

            const v = impl.toValue(l[k].v, l[k].f)
            if (f[v.c].tick) {
              item[k] = v
              has = true
            }
          }

          const isSectionTitle = item.main
          if (isSectionTitle) {
            countTitles++
          }

          if (has || isSectionTitle) {
            nl.push(item)
          }
        }

        if (nl.length > countTitles) {
          result.push({ key: c.key, lines: nl })
        }
      }

      return result
    },

    obsHighlight: function () {
      if (this.flatDistribution == null) {
        return null
      }

      const list = impl.highlight(
        this.distribution, sc.titles, sc.subTitles, sc.facts, parseInt(this.year)
      )
      const result = {}
      for (let c in list) {
        const cat = {}
        for (let i in list[c]) {
          const m = list[c][i]
          const ml = []
          m.forEach(
            mi => {
              const values = []
              mi.values.forEach(
                v => {
                  if (v.v != null && v.v.total > 0) {
                    values.push(impl.toValue(v.v, v.f))
                  }
                }
              )

              if (values.length > 0) {
                ml.push({
                  title: mi.title,
                  subTitle: mi.subTitle,
                  class: mi.class,
                  values: values,
                  lg: mi.lg
                })
              }
            }
          )
          if (ml.length > 0) {
            cat[i] = ml
          }
        }
        if (Object.keys(cat).length > 0) {
          result[c] = cat
        }
      }

      return result
    },

    finalHighlight: function () {
      if (this.obsHighlight == null) {
        return null
      }
      const { m, s } = this.highlight
      if (m == null || s == null) {
        return []
      }
      const hl = this.obsHighlight[m]
      if (hl == null) {
        return []
      }

      const result = hl[s]
      if (result == null) {
        return []
      }
      if (!Array.isArray(result)) {
        return [result]
      }
      return result
    },

    flatDistribution: function () {
      if (this.distribution == null) {
        return null
      }

      try {
        return caracteristics.flatten.observa4(this.distribution, this.region, this.year)
      } catch (e) {
        this.$notify({
          type: 'danger',
          title: 'Erreur !',
          duration: 0,
          content: `Une erreur est survenue pendant le calcul des
caractéristiques : ${e}.`
        })
      }
      return null
    }
  },

  methods: {
    printToPdf: function (type) {
      this.pdf.viewType = type
      this.pdf.filename = `${this.title} - ${sc.highlightTitles(type)}.pdf`
      const pdfPresets = getPdfPresets(type)
      assert.notNull(pdfPresets, 'No pdf variables names for asked export view.')

      const vm = this
      this.pdf.data = pdfPresets.getRawData(vm)
      this.pdf.component = pdfPresets.componentName
      this.pdf.generate = true

      this.$nextTick(
        () => {
          const root = vm.$refs.o4print.$el
          assert.notNull(root)
          pdf.saveToPdf(
            vm.pdf.filename,
            root,
            (c, t) => { vm.setPDFExportProgress(c, t) },
            pdfPresets.jsPDFOpt
          ).then(
            () => {
              vm.pdf.generate = false
              vm.pdf.viewType = null
            }
          )
        }
      )
    },

    setPDFExportProgress (count, total) {
      this.pdf.progress = Math.ceil(count * 100 / total)
      this.pdf.count = count
      this.pdf.total = total
    },

    indexToHighlight: function (index) {
      if (this.highlightMenu == null) {
        return null
      }

      const n = this.highlightMenu.nav.length
      if (n === 0) {
        return {
          m: null, s: null
        }
      }

      let i = index
      while (i < 0) { i += n }
      i = i % n
      return this.highlightMenu.nav[i]
    },

    selectHighlight: function (index) {
      this.highlightIndex = index
    },

    goToNextHighlight: function () {
      this.selectHighlight(this.highlightIndex + 1)
    },

    goToPrevHighlight: function () {
      this.selectHighlight(this.highlightIndex - 1)
    }
  },

  components: {
    'o4-print-pellet-view': o4PrintPelletView,
    'o4-print-table-view': o4PrintTableView,
    'o4-pellet': o4Pellet,
    'o4-result-table': observa4ResultTable,
    suiResultsCaracteristics,
    'c-checkbox': checkbox
  }
}
</script>
<style scoped lang="less">
@import '~variables';
@import '~observa4';

.xportpdf {
  display: flex;
  flex-direction: row;
}

.action-bar {
  padding-left: 1.5rem;
  margin-top: 0.2rem;
  .glyphicon {
    margin-right: 0.4rem;
  }
}

.observa4-results {
  min-height: 100vh;
}

.highlight-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-end;
  margin-left: auto;
  margin-right: auto;

  .result-container {
    position: relative;
    padding: 0.3rem;
    padding-top: 0.1rem;
    max-width: 12rem;
  }

  .result-container-separator::before {
    content: "";
    display: block;
    position: absolute;
    z-index: 1;
    left: 0;
    top: 10%;
    bottom: 10%;
    border: 1px solid fade(@base, 60%);
    border-width: 0 0 0 1px;
  }

  .result-container-big {
    max-width: 14rem;
  }
}

.menu-buttons {
  padding: 0.5rem;

  .btn {
    white-space: normal;
    display: inline-block;
    height: 6rem;
    min-height: 6rem;
    width: 12rem;
  }
}

.line-title {
  font-size: 120%;
}

.menu-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.filter-label {
  margin: 0.2rem;
}

.filter-container {
  padding: 1rem;
  .filter {
    margin: 0.2rem;
    display: inline-block;

  }
  .sheet-filter {
    margin: 0.2rem;
    display: inline-block;
  }
}

.highlight-main {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
}

.highlight {
  padding: 0.5rem;
}

h3 {
  min-width: 16rem;
}

.progress {
  margin-bottom: none;
  .progress-bar {
    transition: none;
  }
}

</style>
